import { defineMessages } from '@transcend-io/internationalization';

export const formMessages = defineMessages('core-ui.Form.form', {
  isRequired: {
    defaultMessage: 'This item is required',
  },
});
